import { useCallback, useState } from 'react';

import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';

import mapStyles from '../../map-styles.json';

type MarkerType = (google.maps.LatLng | google.maps.LatLngLiteral) & {
  title?: string;
};

interface Props {
  center?: google.maps.LatLng | google.maps.LatLngLiteral;
  markers?: Array<MarkerType>;
  zoom?: number;
  fitBounds?: boolean;
}

const containerStyle = {
  width: '100%',
  height: '100%',
};

const MapWithMarkers: React.FC<Props> = ({
  center,
  markers = [],
  zoom = 12,
  fitBounds = false,
}) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY ?? '',
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [map, setMap] = useState<google.maps.Map | null>(null);

  const onLoad = useCallback(
    function callback(map: google.maps.Map) {
      if (fitBounds) {
        if (markers.length > 0) {
          const bounds = new window.google.maps.LatLngBounds();
          markers.forEach((marker) => bounds.extend(marker));
          map.fitBounds(bounds);
        }
      } else if (center) {
        map.setCenter(center);
      }
      setMap(map);
    },
    [center, fitBounds, markers]
  );

  const onUnmount = useCallback(function callback() {
    setMap(null);
  }, []);

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={zoom}
      options={{ styles: mapStyles }}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      {markers.map((marker, inx) => (
        <Marker key={inx} position={marker} icon="/images/map-marker.svg" />
      ))}
    </GoogleMap>
  ) : (
    <></>
  );
};

export default MapWithMarkers;
